import type { ComponentType } from "react";
import type { LanguageShowQueryType } from "@/types/graphql/admin.generated";
import { LanguageDetails } from "../LanguageDetails";

export const LanguageShowComponent: ComponentType<{
  editData?: unknown;
  id?: string;
  language?: LanguageShowQueryType["language"];
}> = ({ language }) => {
  if (!language) return <div>Загрузка...</div>;

  return <LanguageDetails language={language} />;
};
